import { useScroller } from "@/hooks/use-scroller";
import useModelsData from "@/components/pages/home/hooks/use-models-data";
import { VoiceModel } from "@/actions/db/get-models";

export const useDuetsVoiceSelect = (selectedModels: VoiceModel[]) => {
  const scroller = useScroller();
  const modelsData = useModelsData();

  const filteredVoiceList = modelsData.filteredVoiceList.filter(
    (voice) => !selectedModels.some((selected) => selected.id === voice.id),
  );

  return {
    ...modelsData,
    ...scroller,
    filteredVoiceList,
  };
};
